import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "./auth";
import { intialData } from "./initial";

export const collection = createContext();

export default function Collect ({children}) {
    const { ActivEmp, user } = useContext(auth);
    const {intialCategory, initializeEmp, initialProductState, intialConfig, intialSocial, intialInvoice, initialWork, intialClient, intialShift, initInventory } = useContext(intialData);

    const [employee, setEmployee] = useState({});
    const [newProduct, setNewProduct] = useState({});
    const [inventory, setInventory] = useState(initInventory)
    const [cconfig, setCconfig] = useState(intialConfig);
    const [cSocial, setCsocial] = useState(intialSocial);
    const [cInvoice, setCinvoice] = useState(intialInvoice);
    const [cBusniessRules, setCbusinessRules] = useState(initialWork);
    const [categoryText, setCategoryText] = useState(intialCategory);
    const [client, setClient] = useState(intialClient);
    const [shift, setShift] = useState(intialShift);
    const [urlIframe, setUrlIframe] = useState("")

    useEffect(() => {
        setNewProduct(initialProductState());
        setEmployee(initializeEmp);
    }, [ActivEmp, user])


    const parent = {
        employee, 
        setEmployee,
        newProduct, 
        setNewProduct,
        cconfig, 
        setCconfig,
        cSocial, 
        setCsocial,
        setCinvoice,
        cInvoice,
        cBusniessRules,
        setCbusinessRules,
        categoryText, 
        setCategoryText,
        client, 
        setClient,
        shift, 
        setShift,
        urlIframe, 
        setUrlIframe,
        inventory, 
        setInventory
    };
    
    return <collection.Provider value={parent}>{children}</collection.Provider>
}